import React from 'react'
import { media } from 'app/assets/styles'
import { BlazonCardContent } from 'app/common/blazon/card/content/BlazonCardContent'
import { colors } from 'shared/assets/styles'
import type { Blazon } from 'shared/types'
import styled from 'styled-components'

const { shadow } = colors

type Props = {
    blazon: Blazon,
    onClick: () => void,
    disabled?: boolean
}

const BlazonCard = (props: Props) => {
    const { blazon, onClick, disabled = false } = props

    return (
        <Root>
            <BlazonCardContent
                blazon={blazon}
                onClick={onClick}
                disabled={disabled}
            />
        </Root>
    )
}

const Root = styled.div`
    width: 90%;
    max-width: 700px;
    min-height: 124px;
    ${media.medium`
        min-height: 155px;
    `};
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 0 15px ${shadow};
    background-color: white;
`

export { BlazonCard }
